export const LEFT_SIDE_BAR_BODY_TYPES = {
  FILTERS: 'FILTERS',
  CUSTOMIZE_TABLE: 'CUSTOMIZE_TABLE',
};

export const TABS = {
  ALL: 'ALL',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};

export const DEFAULT_COLUMNS = {
  [TABS.ALL]: ['actions', 'quote', 'shipper', 'consignee', 'status', 'service', 'created', 'expiry', 'pallets', 'pieces', 'weight'],
};

export const ADDITIONAL_COLUMNS = [
  'billOfLading', 'originTerminal', 'destinationTerminal', 'charge', 'poNumber', 'customerReferenceNumber', 'deliveryAppointment',
];

export const LABEL_COLUMNS_TRANSLATION_KEY = {
  // Default columns.
  actions: 'Actions',
  quote: 'Quote',
  shipper: 'Shipper',
  consignee: 'Consignee',
  status: 'Status',
  service: 'Service',
  created: 'DateCreated',
  expiry: 'Expiry',
  pallets: 'PalletsDelivery',
  pieces: 'PiecesDelivery',
  weight: 'Weight',
  // Additional columns.
  billOfLading: 'BillLading',
  originTerminal: 'OriginTerminal',
  destinationTerminal: 'DestinationTerminal',
  charge: 'Charge',
  poNumber: 'PurchaseOrder',
  customerReferenceNumber: 'CustomerReferenceNumber',
  deliveryAppointment: 'DeliveryAppointment',
};

export const SERVICE_LEVELS = {
  LTL: 'LTL',
  CBLT: 'CBLT',
  TL: 'TL',
  R: 'R',
  FLB: 'FLB',
};

export const SERVICE_LEVELS_CODES = {
  [SERVICE_LEVELS.LTL]: ['XLT', 'AIR', 'LTL', '9AM'],
  [SERVICE_LEVELS.CBLT]: ['CBLTL'],
  [SERVICE_LEVELS.TL]: ['TL'],
  [SERVICE_LEVELS.R]: ['R1NS', 'R1T', 'R2T', 'R2A', 'R2D', 'R2E', 'R2R'],
  [SERVICE_LEVELS.FLB]: ['FLB'],
};

export const FILTERS_SERVICE_LEVEL = {
  [TABS.ALL]: [SERVICE_LEVELS.LTL, SERVICE_LEVELS.CBLT, SERVICE_LEVELS.TL, SERVICE_LEVELS.R, SERVICE_LEVELS.FLB],
  [TABS.IN_PROGRESS]: [SERVICE_LEVELS.LTL, SERVICE_LEVELS.CBLT, SERVICE_LEVELS.TL, SERVICE_LEVELS.R, SERVICE_LEVELS.FLB],
  [TABS.COMPLETED]: [SERVICE_LEVELS.LTL, SERVICE_LEVELS.CBLT, SERVICE_LEVELS.TL, SERVICE_LEVELS.R, SERVICE_LEVELS.FLB],
};

export const FILTERS_SHIPMENT_SERVICE_TYPE = {
  [TABS.ALL]: ['Regular', 'Exchange', 'Return'],
  [TABS.IN_PROGRESS]: ['Regular', 'Exchange', 'Return'],
  [TABS.COMPLETED]: ['Regular', 'Exchange', 'Return'],
};

export const FILTERS_STATUSES = {
  [TABS.ALL]: [
    'ENTRY', 'AVAIL', 'DISP', 'MISSPCK', 'ATTMPTPCK', 'ATTPUNORE', 'ATTPUREATT', 'DELAPPT', 'PUAPPT', 'DOCK', 'ARRSHIP', 'PICKD', 'APPROSHIP',
    'DEPSHIP', 'ARRTERM', 'DEPARTERM', 'ARRZONE', 'DEPZONE', 'APPROCONS', 'ARRCONS', 'DEPCONS', 'CASSIGN', 'NOTIFY', 'ENRTE', 'DELAYROUTE',
    'APCONSLATE', 'MISSDLVRY', 'DELAYCUST', 'SVCDELAY', 'SVCFAILURE', 'HOLD', 'DELAYBORD', 'APSHIPLATE', 'ATMPTDLV', 'ATTDELREAT', 'ATTDELNORE',
    'HOLDFORPU', 'COMPLETE', 'COMPLETED', 'DELVD', 'ATTPUCANC', 'CANCL', 'NOTIFYCUST',
  ],
  [TABS.IN_PROGRESS]: [
    'DOCK', 'ARRSHIP', 'PICKD', 'APPROSHIP', 'DEPSHIP', 'ARRTERM', 'DEPARTERM', 'ARRZONE', 'DEPZONE', 'APPROCONS', 'ARRCONS', 'DEPCONS',
    'CASSIGN', 'NOTIFY', 'ENRTE', 'DELAYROUTE', 'APCONSLATE', 'MISSDLVRY', 'DELAYCUST', 'SVCDELAY', 'SVCFAILURE', 'HOLD', 'DELAYBORD',
    'APSHIPLATE', 'ATMPTDLV', 'ATTDELREAT', 'ATTDELNORE', 'HOLDFORPU', 'NOTIFYCUST',
  ],
  [TABS.COMPLETED]: ['COMPLETE', 'COMPLETED', 'DELVD'],
};

export const FILTER_MAPPING = {
  shipmentNumber: 'billNumber',
  shipper: 'shipper/name',
  consignee: 'consignee/name',
  status: 'status',
  created: 'CreatedTime',
};

export const SORTING_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};

export const today = new Date();
